<script>
  import { onMount } from "svelte";
  import { slimSelectStore } from "../store/useSlimSelect";

  export let selectsInfo = [
    {
      ajaxUrl: "/ajax/findADentist",
      name: "fadMemberName",
      id: "fadMemberName",
      placeholder: "Search By Dentist",
      defaultLabel:"Dentist name"
    },
    {
      ajaxUrl: "/ajax/findADentist",
      name: "fadLocation",
      id: "fadLocation",
      placeholder: "Search By Location",
      defaultLabel:"Location"
    },
  ];

  let targetId = "userResults";
  let collapse = true;

  onMount(() => {
    slimSelectStore.initialize(selectsInfo);
    slimSelectStore.subscribe(({ values }) => {
      if (Object.keys(values).length > 0) {
        slimSelectStore.performSearch(targetId);
      }
    });
  });

  function reset() {
    slimSelectStore.resetFilters();
  }

</script>


<form id="fadSearch" class="filter-form dentists-filters">

  <button
  on:click={()=>{collapse = !collapse}}
  type="button" class="btn btn-outline-dark btn-mobile btn-filter d-md-none" data-bs-toggle="collapse" data-bs-target=".filter-select-container">FILTER<span class="icon-dropdown">&nbsp;</span></button>

  <div class="filter-select-container navbar-collapse {collapse? 'collapse' : ''}" role="search">

          <div class="filter-select">
              <p class="filter-heading">
                  <strong>SEARCH BY</strong>
              </p>
              {#each selectsInfo as selectInfo, index}
              <select
                bind:this={selectInfo.element}
                data-ajax={selectInfo.ajaxUrl}
                name={selectInfo.name}
                id={selectInfo.id}
                class="slim-select ss-ajax"
                tabindex="-1"
                placeholder={selectInfo.placeholder}
              >
                <option value="">{selectInfo.defaultLabel}</option>
              </select>
              {#if index !== selectsInfo.length - 1}
                <p class="filter-heading">OR</p>
              {/if}
            {/each}
              <button
              type="reset"
              class="btn btn-outline-gray-dark filter-reset"
              id="clear-select"
              disabled={!Object.values($slimSelectStore.values)?.some(v=>v.length > 0)}
              on:click|preventDefault={reset}>Clear</button
            >
          </div>
      </div>
  </form>